export default __webpack_public_path__ + "img/sustan.eb28c3b1.png";